import {
  AfterViewInit,
  Component,
  inject,
  OnInit,
  ViewChild
} from '@angular/core';
import { FilterContainerUtil } from '@app/shared/util/filter-container-util';
import { CommonFilterViewComponent } from '@ntap/common';
import { DeduplikacijaMjestoAttributeStateService } from '@app/shared/services/mjesto-selection-provider.service';
import { NtapListComponent } from '../ntap-list/ntap-list.component';
import {
  DynamicComponent,
  FilterView,
  FilterViewProviderDirective,
  ListView,
  ListViewProviderDirective,
  UIComponents
} from '@ntap/core';

@Component({
  selector: 'app-mjesto-prikaz',
  templateUrl: './mjesto-prikaz.component.html',
  styles: `::ng-deep app-mjesto-prikaz{width:100%}`
})
export class MjestoPrikazComponent
  extends NtapListComponent
  implements OnInit, AfterViewInit
{
  INIT_COMP_ID = UIComponents.LISTVIEW_TABLE;
  currentViewName: string;
  currentViewState: object | null = null;
  currentViewStateFilter: object = {};
  currentViewClass: string;

  private deduplikacijaAttributeStateService = inject(
    DeduplikacijaMjestoAttributeStateService
  );

  @ViewChild('filterContainer') filterContainer: DynamicComponent;

  @ViewChild('listViewProvider')
  override listViewProvider: ListViewProviderDirective<ListView>;

  @ViewChild(FilterViewProviderDirective)
  private filterViewProviderDirective: FilterViewProviderDirective<FilterView>;

  override ngOnInit() {
    super.ngOnInit();
    this.changeView('mjesto');
  }

  changeView(viewName: string) {
    this.currentViewName = viewName;
    this.currentViewState = {};
    this.currentViewStateFilter = {};
    this.currentViewClass = 'list-view-' + viewName;
  }

  ngAfterViewInit() {
    this.listViewProvider.selectedItems$.subscribe((selectedItems) => {
      this.deduplikacijaAttributeStateService.setSelectedMjesta(selectedItems);
    });

    this.filterViewProviderDirective.viewData$.subscribe((filterState) => {
      const currentState = this.listViewProvider.viewState as Record<
        string,
        unknown
      >;
      this.listViewProvider.viewState = {
        ...filterState,
        $parent: currentState?.['$parent']
      };
    });

    if (this.filterContainer) {
      const filterComponent =
        this.filterContainer.getViewComponent() as CommonFilterViewComponent;
      FilterContainerUtil.separateOsnovnaNaprednaPretraga(filterComponent);
    }
  }
}
